import { Action } from 'redux';

export enum RecentClientsActionTypes {
	RECENT_CLIENTS_RESULTS_GET = '@@recent-clients/RECENT_CLIENTS_RESULTS_GET',
	RECENT_CLIENTS_RESULTS_SUCCESS = '@@recent-clients/RECENT_CLIENTS_RESULTS_SUCCESS',
	RECENT_CLIENTS_RESULTS_FAILURE = '@@recent-clients/RECENT_CLIENTS_RESULTS_FAILURE',
	RECENT_CLIENTS_RESULTS_LOADING = '@@recent-clients/RECENT_CLIENTS_RESULTS_LOADING',
}

export interface RecentClientsTryGetResultsAction extends Action {
	readonly type: RecentClientsActionTypes.RECENT_CLIENTS_RESULTS_GET;
	adviserUUID: string;
}

export interface RecentClientsGetResultsSuccessAction extends Action {
	readonly type: RecentClientsActionTypes.RECENT_CLIENTS_RESULTS_SUCCESS;
	response?: any;
}

export interface RecentClientsGetResultsFailureAction extends Action {
	readonly type: RecentClientsActionTypes.RECENT_CLIENTS_RESULTS_FAILURE;
	message?: string;
}

export interface RecentClientsGetResultsLoadingAction extends Action {
	readonly type: RecentClientsActionTypes.RECENT_CLIENTS_RESULTS_LOADING;
	message?: string;
}

export type RecentClientsAction =
	| RecentClientsTryGetResultsAction
	| RecentClientsGetResultsSuccessAction
	| RecentClientsGetResultsFailureAction
	| RecentClientsGetResultsLoadingAction;

export function getRecentClientsResultsAction(
	adviserUUID: string
): RecentClientsTryGetResultsAction {
	return {
		type: RecentClientsActionTypes.RECENT_CLIENTS_RESULTS_GET,
		adviserUUID,
	};
}
